import React from 'react';
import { message as customMessage } from 'antd';

const toast = (message: string, type = 'info') => {
  switch (type) {
    case 'info':
      customMessage.info(message);
      break;
    case 'success':
      customMessage.success(message);
      break;
    case 'error':
      customMessage.error(message);
      break;
    case 'warn':
      customMessage.warn(message);
      break;
    default:
      break;
  }
};

export default toast;
